document.addEventListener("DOMContentLoaded", () => {
  /* Owl Carousel */
  var owl = $(".owl-carousel");

  owl.owlCarousel({
    slideSpeed: 400,
    paginationSpeed: 400,
    responsiveRefreshRate: 100,
    autoPlay: false,
    stopOnHover: true,

    // Navigation
    navigation: false,
    rewindNav: true,
    scrollPerPage: true,

    //Pagination
    pagination: true,

    singleItem: true,
    lazyLoad: true,
    autoHeight: true,
  });

  $(".previous-next > .previous").click(function () {
    owl.trigger("owl.prev");
  });

  $(".previous-next > .next").click(function () {
    owl.trigger("owl.next");
  });

  /* Main Navigation Toggle */

  $(".menu-toggle").click(function () {
    $("#company-nav-off-canvas").toggleClass("active");
  });

  /* Sub nav hovers */

  var header_drop_downs = $("ul.company-navigation > li");
  var off_canvas_drop_down = $(
    "#company-nav-off-canvas ul.company-navigation > li"
  );

  function sub_nav_hover_on() {
    if ($(this).find("ul").length) {
      $(this).find("ul").addClass("active");
    } else {
      return;
    }
  }

  function sub_nav_hover_off() {
    if ($(this).find("ul").length) {
      $(this).find("ul").removeClass("active");
    } else {
      return;
    }
  }

  header_drop_downs.hoverIntent({
    over: sub_nav_hover_on,
    out: sub_nav_hover_off,
    timeout: 300,
  });

  $(off_canvas_drop_down).each(function () {
    var button = $(this).find("a").first();

    if ($(this).find("ul").length) {
      $(this).parent().addClass("accordion");

      button.addClass("acc-button");

      if (button.hasClass("selected")) {
        button.closest("li").addClass("active");
        button.find(".fa").html("&#xf0d8;");
      }
    } else {
      return;
    }
  });

  $(header_drop_downs).each(function () {
    var button = $(this).find("a").first();

    if ($(this).find("ul").length) {
      button.append('<span class="fa">&#xf0d7;</span>');
    } else {
      return;
    }
  });

  /* Accordions */

  $(".acc-button").click(function (e) {
    e.preventDefault();

    var all_others = $(this)
      .closest(".accordion, .link-list, .collapsable")
      .find(".acc-button");

    all_others.removeClass("active").next().slideUp("fast");
    all_others.find(".fa").html("&#xf0d7;");

    if ($(this).next().is(":hidden") === true) {
      $(this).find(".fa").html("&#xf0d8;");

      $(this).addClass("active");
      $(this).next().slideDown("fast");
    }
  });

  // Added from legacy site

  var url = window.location;
  var sharingEndpoint = "http://api.addthis.com/oexchange/0.8/forward/";

  $(".facebook a").attr("href", sharingEndpoint + "facebook/offer?url=" + url);
  $(".twitter a").attr("href", sharingEndpoint + "twitter/offer?url=" + url);
  $(".email a").attr(
    "href",
    "mailto:?subject=I wanted you to see this Mr. Ellie Pooh page.&body=" + url
  );

  $(".thumbnails li:first-child").addClass("selected");

  var first_url;
  var console;

  first_url = $(".thumbnails li:first-child a").attr("href");

  $(".thumbnails li a").click(function (e) {
    e.preventDefault();

    $(this).parents().eq(2).find("li").removeClass("selected");
    $(this).parents().eq(0).addClass("selected");

    url = $(this).attr("href");

    $("div.zoom img").attr("src", url);

    return false;
  });

  $("button.disabled").click(function (e) {
    e.preventDefault();
  });
   

  /* Magnific popup */

  var standardOptions = {
    closeOnContentClick: false,
    closeBtnInside: true,
    preloader: true,
    callbacks: {
      open: function() {
        $('html').addClass('popup-active');
      },
      close: function() {
        $('html').removeClass('popup-active');
      }
    } 
  };

  $('a:not(.ajax):has(span.fa-search-plus), .gallery-grid a').magnificPopup($.extend({}, standardOptions, {
      type: 'image',
      gallery:{
          enabled:true
      }
  }));

});
